module.exports = __webpack_public_path__ + "img/bixiu03.fe1bdb0b.png";